/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreateWillRequestDto } from '../models/CreateWillRequestDto';
import type { UpdateWillRequestStatusDto } from '../models/UpdateWillRequestStatusDto';
import type { WillRequestDto } from '../models/WillRequestDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class WillRequestsService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Create a new will request
     * @param requestBody Data for creating a will request
     * @returns WillRequestDto The will request has been successfully created.
     * @throws ApiError
     */
    public willRequestsControllerCreateWillRequest(
        requestBody: CreateWillRequestDto,
    ): Observable<WillRequestDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/will-requests',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all will requests with pagination and filtering - Super Admin only
     * @param page Page number (default: 1)
     * @param limit Items per page (default: 10)
     * @param sortActive Field to sort by (default: created_at)
     * @param sortDirection Sort direction (default: desc)
     * @param filter Search filter for name or email
     * @param statuses Filter by will status
     * @param charityIds Filter by charity IDs
     * @param solicitorIds Filter by solicitor IDs
     * @returns any All will requests retrieved successfully
     * @throws ApiError
     */
    public willRequestsControllerGetAllWillRequests(
        page?: number,
        limit?: number,
        sortActive?: string,
        sortDirection?: 'asc' | 'desc',
        filter?: string,
        statuses?: Array<string>,
        charityIds?: Array<string>,
        solicitorIds?: Array<string>,
    ): Observable<{
        data: Array<WillRequestDto>;
        total: number;
        page: number;
        limit: number;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/will-requests',
            query: {
                'page': page,
                'limit': limit,
                'sortActive': sortActive,
                'sortDirection': sortDirection,
                'filter': filter,
                'statuses': statuses,
                'charityIds': charityIds,
                'solicitorIds': solicitorIds,
            },
        });
    }
    /**
     * Get will requests by charity with pagination and filtering
     * @param charityId The UUID of the charity
     * @param page Page number (default: 1)
     * @param limit Items per page (default: 10)
     * @param sortActive Field to sort by (default: created_at)
     * @param sortDirection Sort direction (default: desc)
     * @param filter Search filter for name or email
     * @param statuses Filter by will status
     * @param solicitorIds Filter by solicitor IDs
     * @returns any Will requests for charity retrieved successfully
     * @throws ApiError
     */
    public willRequestsControllerGetWillRequestsByCharity(
        charityId: string,
        page?: number,
        limit?: number,
        sortActive?: string,
        sortDirection?: 'asc' | 'desc',
        filter?: string,
        statuses?: Array<string>,
        solicitorIds?: Array<string>,
    ): Observable<{
        data: Array<WillRequestDto>;
        total: number;
        page: number;
        limit: number;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/will-requests/charity/{charityId}',
            path: {
                'charityId': charityId,
            },
            query: {
                'page': page,
                'limit': limit,
                'sortActive': sortActive,
                'sortDirection': sortDirection,
                'filter': filter,
                'statuses': statuses,
                'solicitorIds': solicitorIds,
            },
        });
    }
    /**
     * Get all will requests with pagination and filtering by solicitor
     * @param solicitorId The UUID of the solicitor
     * @param page Page number (default: 1)
     * @param limit Items per page (default: 10)
     * @param sortActive Field to sort by (default: created_at)
     * @param sortDirection Sort direction (default: desc)
     * @param filter Search filter for name or email
     * @param statuses Filter by will status
     * @param charityIds Filter by charity IDs
     * @returns any Will requests retrieved successfully
     * @throws ApiError
     */
    public willRequestsControllerGetWillRequestsBySolicitor(
        solicitorId: string,
        page?: number,
        limit?: number,
        sortActive?: string,
        sortDirection?: 'asc' | 'desc',
        filter?: string,
        statuses?: Array<string>,
        charityIds?: Array<string>,
    ): Observable<{
        data: Array<WillRequestDto>;
        total: number;
        page: number;
        limit: number;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/will-requests/{solicitorId}',
            path: {
                'solicitorId': solicitorId,
            },
            query: {
                'page': page,
                'limit': limit,
                'sortActive': sortActive,
                'sortDirection': sortDirection,
                'filter': filter,
                'statuses': statuses,
                'charityIds': charityIds,
            },
        });
    }
    /**
     * Get a will request by ID with full details including documents
     * @param id The UUID of the will request
     * @returns any Will request details retrieved successfully
     * @throws ApiError
     */
    public willRequestsControllerGetWillRequestById(
        id: string,
    ): Observable<{
        id?: string;
        firstName?: string;
        lastName?: string;
        email?: string;
        phone?: string;
        status?: 'NEW' | 'ACCEPTED_BY_SOLICITOR' | 'DECLINED' | 'ASSIGNED_TO_SOLICITOR' | 'WILL_COMPLETE' | 'PAYMENT_DECLINED' | 'REQUEST_COMPLETE' | 'DECLINED_BY_SOLICITOR' | 'DECLINED_BY_PLATFORM';
        charity?: Record<string, any>;
        supporter?: Record<string, any>;
        solicitor?: Record<string, any>;
        documents?: Array<Record<string, any>>;
        workflowHistory?: Array<Record<string, any>>;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/will-requests/{id}/details',
            path: {
                'id': id,
            },
            errors: {
                404: `Will request not found`,
            },
        });
    }
    /**
     * Update a will request with optional document uploads
     * @param id The UUID of the will request
     * @param formData
     * @returns WillRequestDto Will request updated successfully
     * @throws ApiError
     */
    public willRequestsControllerUpdateWillRequest(
        id: string,
        formData: {
            firstName?: string;
            lastName?: string;
            email?: string;
            dateOfBirth?: string;
            phone?: string;
            notes?: string;
            addressLine1?: string;
            addressLine2?: string;
            city?: string;
            state?: string;
            postalCode?: string;
            dateOfWill?: string;
            status?: 'NEW' | 'ACCEPTED_BY_SOLICITOR' | 'DECLINED' | 'ASSIGNED_TO_SOLICITOR' | 'WILL_COMPLETE' | 'PAYMENT_DECLINED' | 'REQUEST_COMPLETE' | 'DECLINED_BY_SOLICITOR' | 'DECLINED_BY_PLATFORM';
            type?: 'SINGLE' | 'JOINT';
            giftToCharity?: boolean;
            conditionalGift?: boolean;
            description?: string;
            estimatedGiftValue?: number;
            consentToShare?: boolean;
            giftType?: string;
            charityId?: string;
            solicitorId?: string;
            /**
             * Optional document files to upload
             */
            documents?: Array<Blob>;
        },
    ): Observable<WillRequestDto> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/will-requests/{id}',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Update will request status with workflow history tracking
     * @param id The UUID of the will request
     * @param requestBody Status update data with optional note
     * @returns any Will request status updated successfully
     * @throws ApiError
     */
    public willRequestsControllerUpdateWillRequestStatus(
        id: string,
        requestBody: UpdateWillRequestStatusDto,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/api/will-requests/{id}/status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Export will requests to CSV file
     * @param charityId Filter by charity ID
     * @param willRequestIds Specific will request IDs to export
     * @returns any CSV export created successfully
     * @throws ApiError
     */
    public willRequestsControllerExportWillRequestsToCsv(
        charityId?: string,
        willRequestIds?: Array<string>,
    ): Observable<{
        downloadUrl?: string;
        fileName?: string;
        message?: string;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/will-requests/export/csv',
            query: {
                'charityId': charityId,
                'willRequestIds': willRequestIds,
            },
            errors: {
                404: `No will requests found for the given criteria`,
            },
        });
    }
}
